<ng-container [formGroup]="instructionForm">
  <form [formGroup]="instructionForm" class="instruction-form">
      <div class="form-wrapper input-wrapper">
          <!-- Type -->
          <mat-form-field class="form-field">
              <mat-label>Type</mat-label>
              <mat-select formControlName="type" (selectionChange)="resetFieldsOnTypeChange()"
                  [(value)]="instructionBuilderService.instruction().details.type">
                  @for (instructionType of instructionTypes; track instructionType.value) {
                  <mat-option [value]="instructionType.value">
                      {{ instructionType.viewValue }}
                  </mat-option>
                  }
              </mat-select>
          </mat-form-field>

          <ng-container class="instruction-definition-conditional-fields">

              <!-- Instruction Prompt Fields -->
              <ng-container>
                  <!-- Instruction Prompt -->
                  <!-- INFO commenting out for now. may implement later in v2 -->
                  <!--
                  <mat-form-field class="form-field">
                      <mat-label>Instruction Prompt</mat-label>
                      <textarea matInput formControlName="instructionPrompt" rows="4"
                          placeholder="Enter your Instruction prompt"></textarea>
                      @if (instructionForm.get('instructionPrompt')?.hasError('required')) {
                      <mat-error class="mat-mdc-form-field-error error">
                          Instruction Prompt is required
                          </mat-error>
                          }
                  </mat-form-field> -->

                  <!-- Prompt -->
                  <div class="info-box">
                      <mat-icon fontIcon="info"/>
                      <span>{{instructionPromptInfoText}}</span>
                  </div>
                  <mat-form-field class="form-field">
                      <mat-label>Prompt</mat-label>
                      <textarea matInput formControlName="prompt" rows="4"
                          placeholder="Enter your prompt"></textarea>
                      @if (instructionForm.get('prompt')?.hasError('required')) {
                      <mat-error class="mat-mdc-form-field-error error">
                          Prompt is required
                      </mat-error>
                      }
                  </mat-form-field>
              </ng-container>

              <!-- Conditional fields based on selected type -->
              @switch(instructionForm.get('type')?.value) {

              @case (InstructionType.Agent) {
              <!-- Agent Fields -->
              <ng-container>
                  @if (instructionForm.get('agent')!.hasError('required')) {
                      <mat-error class="mat-mdc-form-field-error error">
                          An Agent is required.
                      </mat-error>
                  }
                @defer (when agentsLoaded()) {
                  <app-agent-table [showTableDetails]="true" [(gridData)]="gridView"
                      [showExcelExportButton]="showExcelExportButton()" [showActionsColumn]="showActionsColumn()"
                      [showGoToMostRecentSessionButton]="showGoToMostRecentSessionButton()"
                      [hideCreateAgentButton]="true" [tableTooltipText]="tableTooltipText()"
                      [selectableMode]="selectableMode()"
                      [initialSelectedAgentId]="instructionBuilderService.instruction().details.agent || ''"
                      [tableColumns]="[
                      { field: 'checkboxField', width: 45, isSelectAll: false, hidden: false },
                      { field: 'name', title: 'Name', width: 300 },
                      { field: 'description', title: 'Description' },
                      { field: 'sensitivityLabelList', title: 'Sensitivity Label', hidden: true },
                      ]"
                      (agentSelectionChanged)="updateInstructionWithAgents($event)" />
                } @placeholder {
                  <div class="loading-placeholder">Loading agents...</div>
                }
                  <!-- Sensitivity Labels -->
                  @if (instructionBuilderService.instruction().details.agent) {
                  <div class="form-group">
                      <div class="info-box">
                        <div>
                          <mat-icon fontIcon="info"/>
                        </div>
                          <span>Sensitivity Label for the Instruction is set by the Agent you select
                              in the table above. This is only if you selected the Agent Instruction
                              Type.
                              Ex. If you pick an Agent with Public and Highly Confidential Sensitivity
                              Labels, those Sensitivity Labels will be set for the Instruction.</span>
                      </div>
                      <div class="tree-view">
                          @if (instructionForm.get('sensitivityLabels')!.hasError('sensitivityLabelInvalid') || instructionForm.get('sensitivityLabels')!.hasError('required')) {
                          <mat-error class="mat-mdc-form-field-error error">At least one Sensitivity Label is
                              required.</mat-error>
                          }
                          <kendo-treeview
                          [nodes]="filteredSensitivityLabelData()"
                          textField="label"
                          idField="id"
                          parentIdField="parentId"
                          checkBy="id"
                          [filterable]="false"
                          [loadOnDemand]="false"
                          [(checkedKeys)]="checkedKeys"
                          [expandedKeys]="expandedKeys"
                          [hasCheckbox]="hasCheckbox"
                          (checkedChange)="onSelectionChange($event)"
                          kendoTreeViewFlatDataBinding
                          kendoTreeViewExpandable
                          [kendoTreeViewDisable]="'label'"
                          [kendoTreeViewCheckable]="checkableSettings"
                          [isDisabled]="isSensitivityLabelDisabled"
                              >
                              <ng-template kendoTreeViewNodeTemplate let-dataItem>
                                  <div class="tree-node">
                                      <mat-icon class="material-symbols-outlined red-shield"
                                          [ngClass]="{'red-shield': dataItem.icon === 'safety_check_off'}"
                                          [fontIcon]="dataItem.icon" />
                                      <span>{{ dataItem.label }}</span>
                                  </div>
                              </ng-template>
                          </kendo-treeview>
                      </div>
                  </div>
                  }
              </ng-container>
              }

              @case (InstructionType.FileUpload) {
              <!-- File Upload Fields -->
              <ng-container>
                  <div class="info-box">
                      <mat-icon fontIcon="info"/>
                      <span>"Read CGI Federal File" Agent is automatically selected for file upload
                          instructions</span>
                  </div>
                  <mat-form-field class="form-field">
                      <mat-label>File Upload Label</mat-label>
                      <input matInput formControlName="fileUploadLabel"
                          placeholder="Enter label for file upload request">
                      <mat-hint>The context you wish to ask for a file to be uploaded</mat-hint>
                      @if (instructionForm.get('fileUploadLabel')?.hasError('required')) {
                      <mat-error>
                          File upload label is required
                      </mat-error>
                      }
                  </mat-form-field>
              </ng-container>
              }

              @case (InstructionType.CollectInformation) {
              <!-- Collect Information Fields -->
              <ng-container>
                  <mat-form-field class="form-field">
                      <mat-label>Collect information input</mat-label>
                      <input matInput formControlName="collectInformationLabel"
                          placeholder="Information to collect">
                      <mat-hint>This will create a text input for the user to add more information for the prompt.</mat-hint>
                      @if (instructionForm.get('collectInformationLabel')?.hasError('required')) {
                      <mat-error>
                          Information field is required
                      </mat-error>
                      }
                  </mat-form-field>
              </ng-container>
              }
              }

              <!-- Sensitivity Labels -->
              @if (instructionBuilderService.instruction().details.type != InstructionType.Agent) {
              <div class="form-group">
                  <div class="info-box">
                      <div>
                          <mat-icon fontIcon="info" />
                      </div>
                      <span>Sensitivity Label for the Instruction is set by the Agent you select
                          in the table above. This is only if you selected the Agent Instruction
                          Type.
                          Ex. If you pick an Agent with Public and Highly Confidential Sensitivity
                          Labels, those Sensitivity Labels will be set for the Instruction.</span>
                  </div>
                  <div class="tree-view">
                      @if (instructionForm.get('sensitivityLabels')!.hasError('sensitivityLabelInvalid') ||
                      instructionForm.get('sensitivityLabels')!.hasError('required')) {
                      <mat-error class="mat-mdc-form-field-error error">At least one Sensitivity Label is
                          required.</mat-error>
                      }
                      <kendo-treeview [nodes]="filteredSensitivityLabelData()" textField="label" idField="id" parentIdField="parentId"
                          checkBy="id" [filterable]="false" [loadOnDemand]="false" [(checkedKeys)]="checkedKeys"
                          [expandedKeys]="expandedKeys" [hasCheckbox]="hasCheckbox" (checkedChange)="onSelectionChange($event)"
                          kendoTreeViewFlatDataBinding kendoTreeViewExpandable [kendoTreeViewDisable]="'label'"
                          [kendoTreeViewCheckable]="checkableSettings" [isDisabled]="isSensitivityLabelDisabled">
                          <ng-template kendoTreeViewNodeTemplate let-dataItem>
                              <div class="tree-node">
                                  <mat-icon class="material-symbols-outlined red-shield"
                                      [ngClass]="{'red-shield': dataItem.icon === 'safety_check_off'}" [fontIcon]="dataItem.icon" />
                                  <span>{{ dataItem.label }}</span>
                              </div>
                          </ng-template>
                      </kendo-treeview>
                  </div>
              </div>
              }
          </ng-container>
      </div>
  </form>
</ng-container>
